import LANDING_PAGE from './landingPage';
import HEADER from './header';
import DASHBOARD from './dashboard';
import SWAP from './swap';
import CREATE_WALLET from './createWallet';
import ACCESS_WALLET from './accessWallet';
import BUY_SELL from './buySell';
import STAKING from './staking';
import CONTRACT from './contract';
import TRENDING_TOKENS from './trendingTokens';

const COMMON = {
  PAGE_SHOWN: 'PageShown',
  GOOGLE_STORE: 'GoogleStore',
  MEW_WALLET: 'MEWWallet'
};

export {
  LANDING_PAGE,
  HEADER,
  DASHBOARD,
  SWAP,
  CREATE_WALLET,
  COMMON,
  ACCESS_WALLET,
  BUY_SELL,
  CONTRACT,
  STAKING,
  TRENDING_TOKENS
};
